"use strict";
exports.__esModule = true;
var inlineBtoa = function (str) { return Buffer.from(str, 'binary').toString('base64'); };
exports["default"] = inlineBtoa;
//# sourceMappingURL=inlineBtoa.js.map